export default __webpack_public_path__ + "static/media/MY.f8d3ab59.svg";